/** @format */

import { Dropdown } from "primereact/dropdown";
import { InputSwitch } from "primereact/inputswitch";
import { Draggable } from "react-beautiful-dnd";
import { ReactComponent as CopySurvey } from "../../../assets/CopySurvey.svg";
import { ReactComponent as DeleteSurvey } from "../../../assets/DeleteSurvey.svg";
import { ReactComponent as AddSurvey } from "../../../assets/addSurvey.svg";
import { QUESTION_TYPES, getQuestion } from "../utils/utils";
import MultipleChoiceTemplate from "./MultipleChoiceTemplate";
import ShortAnswerTemplate from "./ShortAnswerTemplate";

const QuestionTemplate = ({
  questionIndex,
  optionRequestDTOS,
  answerLength,
  isMultipleChoice,
  isShortAnswer,
  setSurvey,
  type,
  name,
  isRequired,
  question,
  questionsLength,
}) => {
  return (
    <Draggable draggableId={`draggable-${questionIndex}`} index={questionIndex}>
      {(provided, snapshot) => (
        <div key={questionIndex} ref={provided.innerRef} {...provided.draggableProps}>
          <p className='my-6'>Select Question Type</p>
          <div className='survey__question__container p-3'>
            <div className='p-fluid'>
              <div className='field flex'>
                <Dropdown
                  name='questionType'
                  options={QUESTION_TYPES}
                  value={type}
                  onChange={(e) => {
                    setSurvey((draft) => {
                      draft.questionRequestDTOS[questionIndex] = getQuestion(e.value);
                    });
                  }}
                  style={{ width: "250px" }}
                />
                <i className='pi pi-bars ml-auto' style={{ fontSize: "2em" }} {...provided.dragHandleProps}></i>
              </div>
              {isMultipleChoice ? (
                <MultipleChoiceTemplate
                  name={name}
                  setSurvey={setSurvey}
                  questionIndex={questionIndex}
                  optionRequestDTOS={optionRequestDTOS}
                  answerLength={answerLength}
                />
              ) : null}
              {isShortAnswer ? (
                <ShortAnswerTemplate name={name} setSurvey={setSurvey} questionIndex={questionIndex} />
              ) : null}

              <div className='field flex mt-5 mb-0 align-items-start'>
                {isMultipleChoice ? (
                  <MultipleChoiceTemplate.AddOptions
                    answerLength={answerLength}
                    setSurvey={setSurvey}
                    questionIndex={questionIndex}
                  />
                ) : null}
                <div className='flex align-items-center ml-auto survey__actions'>
                  <QuestionTemplate.Actions
                    setSurvey={setSurvey}
                    question={question}
                    questionIndex={questionIndex}
                    isRequired={isRequired}
                    questionsLength={questionsLength}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Draggable>
  );
};

QuestionTemplate.Actions = ({ setSurvey, questionIndex, isRequired, question, questionsLength }) => {
  return (
    <>
      <span>Required</span>
      <InputSwitch
        checked={isRequired}
        className='ml-2'
        style={{ height: "25px" }}
        onChange={(e) => {
          let value = e.value;
          setSurvey((draft) => {
            draft.questionRequestDTOS[questionIndex].isRequired = value;
          });
        }}
      />
      <CopySurvey
        className='ml-2'
        width={27}
        height={27}
        onClick={(e) => {
          setSurvey((draft) => {
            draft.questionRequestDTOS.splice(questionIndex + 1, 0, question);
          });
        }}
      />
      <DeleteSurvey
        className='ml-2'
        width={30}
        height={30}
        disabled={questionsLength === 1}
        style={{
          cursor: questionsLength === 1 ? "not-allowed" : "pointer",
          opacity: questionsLength === 1 ? "0.5" : "1",
        }}
        onClick={(e) => {
          if (questionsLength === 1) return;
          setSurvey((draft) => {
            draft.questionRequestDTOS.splice(questionIndex, 1);
          });
        }}
      />
      <AddSurvey
        className='ml-2'
        width={30}
        height={30}
        onClick={(e) => {
          setSurvey((draft) => {
            draft.questionRequestDTOS.push(getQuestion());
          });
        }}
      />
    </>
  );
};
export default QuestionTemplate;
